import { SearchWidget } from '@/features/search/components/SearchWidget';
import { usePageSection } from '@/hooks/usePageContent';

interface HeroContent {
    heading: string;
    subheading: string;
}

const DEFAULT_HERO: HeroContent = {
    heading: 'Quality Baby Gear, on Your Terms',
    subheading:
        'Rent for holidays or rent for home; rent to try it, or for as long as you need it. We keep the gear premium and the process flexible, so you can choose the baby equipment that works for your family, on your terms.',
};

export const HeroSection = () => {
    const cms = usePageSection<HeroContent>('home', 'hero');
    const content = cms ?? DEFAULT_HERO;

    return (
        <section className="relative isolate overflow-hidden bg-[linear-gradient(180deg,rgba(246,246,233,1)_0%,rgba(242,238,208,0.98)_56%,rgba(246,246,233,1)_100%)] pb-12 pt-8 sm:pb-18 sm:pt-12 lg:pb-20 lg:pt-10">

            <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                {/* Headline block — full width */}
                <div className="max-w-3xl">
                    <h1 className="delight-rise font-display text-[clamp(2.85rem,6vw,4.9rem)] leading-[0.94] tracking-tight text-foreground">
                        {content.heading}
                    </h1>

                    <p className="delight-rise delight-delay-1 mt-4 max-w-2xl text-base leading-7 text-muted-foreground sm:text-lg">
                        {content.subheading}
                    </p>
                </div>

                {/* Full-width search bar — sits below the headline row */}
                <div className="delight-rise delight-delay-2 mt-8 w-full sm:mt-10">
                    <SearchWidget variant="hero" />
                </div>
            </div>
        </section>
    );
};
